export default __webpack_public_path__ + "static/media/MusicalIntruments_41.900b613d.png";